import { EventEmitter, Provider, SimpleChanges } from '@angular/core';
import { ATTRIBUTION_MODE_LABELS } from 'SecuritiesApp/ts/features/attribution-factor-analysis/attribution-bar-chart-constants';
import { ScatterPlotStatus } from 'ChartApp/ts/enums/scatter-plot-common.enum';
import { AttributionMode } from 'SecuritiesApp/ts/features/attribution-factor-analysis/attribution-bar-chart-enums';
import { PerformancePeriodicity, } from 'SecuritiesApp/ts/interfaces/attribution.interface';
import { YChartsSentryUtils } from 'Angular/services/sentry/sentry-utils';
import { ChartZoomService } from 'ChartApp/ts/features/charts-shared/services/chart-zoom.service';
import { ScatterPlotBaseDirective } from 'ChartApp/ts/features/scatter-plot/directives/scatter-plot-base.directive';
import { convertNestedStringToBoolean } from 'Angular/utils/state-utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i4 from "../../../../../../../../charts/static/charts/ts/features/scatter-plot/components/scatter-plot/scatter-plot.component";
const _c0 = a0 => ({ "chart-control-item": true, "current": a0 });
const _forTrack0 = ($index, $item) => $item.value;
function AttributionFactorScatterPlotComponent_For_10_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 8)(1, "a", 19);
    i0.ɵɵlistener("click", function AttributionFactorScatterPlotComponent_For_10_Template_a_click_1_listener() { const periodicityOption_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.updatePeriodicityHandler.emit(periodicityOption_r4.value)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const periodicityOption_r4 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, periodicityOption_r4.value === ctx_r4.performancePeriodicity));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", periodicityOption_r4.label, " ");
} }
function AttributionFactorScatterPlotComponent_For_18_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 22);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(2, "span", 23);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    const item_r7 = ctx_r5.$implicit;
    const ɵ$index_35_r8 = ctx_r5.$index;
    i0.ɵɵadvance();
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("text-", ɵ$index_35_r8 + 1));
    i0.ɵɵproperty("name", "icon-shape-cross");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r7);
} }
function AttributionFactorScatterPlotComponent_For_18_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    const item_r7 = ctx_r5.$implicit;
    const ɵ$index_35_r8 = ctx_r5.$index;
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("chart-legend-item-title bullet-", ɵ$index_35_r8 + 1));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r7);
} }
function AttributionFactorScatterPlotComponent_For_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵconditionalCreate(1, AttributionFactorScatterPlotComponent_For_18_Conditional_1_Template, 4, 5, "div", 20)(2, AttributionFactorScatterPlotComponent_For_18_Conditional_2_Template, 2, 4, "div", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ɵ$index_35_r8 = ctx.$index;
    const ɵ$count_35_r9 = ctx.$count;
    i0.ɵɵadvance();
    i0.ɵɵconditional(ɵ$index_35_r8 === ɵ$count_35_r9 - 1 ? 1 : 2);
} }
const chartZoomProviders = [{ provide: ChartZoomService, useClass: ChartZoomService }];
export class AttributionFactorScatterPlotComponent extends ScatterPlotBaseDirective {
    constructor() {
        super(...arguments);
        this.updatePeriodicityHandler = new EventEmitter();
        this.chartLegendItemLabels = [];
        this.status = ScatterPlotStatus.loading;
        this.ATTRIBUTION_MODE_LABELS = ATTRIBUTION_MODE_LABELS;
    }
    ngOnChanges(changes) {
        if (changes.fetchHandler?.currentValue) {
            this.fetchSubscription = this.handleFetch();
        }
    }
    handleFetch() {
        if (this.fetchHandler) {
            this.status = ScatterPlotStatus.loading;
            return this.fetchHandler.subscribe({
                next: (attributionData) => {
                    const keys = Object.keys(attributionData.data);
                    this.chartLegendItemLabels = [];
                    keys.forEach((key) => {
                        if (attributionData.data[key].label !== 'Intercept') {
                            this.chartLegendItemLabels.push(attributionData.data[key].label);
                        }
                    });
                    this.chartLegendItemLabels.push(this.securityName);
                    this.scatterplotData = attributionData.scatterplot;
                    convertNestedStringToBoolean(this.scatterplotData);
                    this.status = ScatterPlotStatus.ok;
                },
                error: (error) => {
                    this.status = ScatterPlotStatus.error;
                    this.error = error.error;
                    // Only capture unexpected exceptions
                    if (!this.backendErrorCodes.has(this.error.code)) {
                        YChartsSentryUtils.captureException(error);
                    }
                },
            });
        }
        this.status = ScatterPlotStatus.error;
        return null;
    }
}
AttributionFactorScatterPlotComponent.ɵfac = /*@__PURE__*/ (() => { let ɵAttributionFactorScatterPlotComponent_BaseFactory; return function AttributionFactorScatterPlotComponent_Factory(__ngFactoryType__) { return (ɵAttributionFactorScatterPlotComponent_BaseFactory || (ɵAttributionFactorScatterPlotComponent_BaseFactory = i0.ɵɵgetInheritedFactory(AttributionFactorScatterPlotComponent)))(__ngFactoryType__ || AttributionFactorScatterPlotComponent); }; })();
AttributionFactorScatterPlotComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AttributionFactorScatterPlotComponent, selectors: [["ycn-attribution-factor-scatter-plot"]], inputs: { fetchHandler: "fetchHandler", securityName: "securityName", selectedAttribution: "selectedAttribution", periodicityOptions: "periodicityOptions", performancePeriodicity: "performancePeriodicity" }, outputs: { updatePeriodicityHandler: "updatePeriodicityHandler" }, standalone: false, features: [i0.ɵɵProvidersFeature(chartZoomProviders), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 24, vars: 5, consts: [["helpModal", ""], [1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "help-toggler", 3, "click"], [1, "panel-actions"], [1, "panel-action"], [1, "chart-control", "chart-control-compact", "border-0"], [3, "ngClass"], [1, "panel-content"], [1, "chart-cover"], [1, "chart-interactive"], [1, "chart-item"], [1, "chart-options"], [1, "chart-legend"], [1, "chart-legend-item"], [1, "chart-wrap", "full-height"], [1, "full-height"], [1, "chart-canvas", "d-flex", "flex-column", 2, "height", "650px", 3, "errorMessage", "scatterPlotInfo", "status", "ychartsScatterPlotService"], ["href", "javascript:void(0)", 1, "chart-control-link", 3, "click"], [1, "chart-legend-item-title"], [3, "class"], ["ycnIcon", "", 3, "name"], [2, "margin-left", "5px"]], template: function AttributionFactorScatterPlotComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "h3", 3);
        i0.ɵɵtext(3);
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵlistener("click", function AttributionFactorScatterPlotComponent_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(23); return i0.ɵɵresetView(helpModal_r2.openModal("attribution_factor_scatter_plot")); });
        i0.ɵɵtext(5, " (?) ");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 5)(7, "div", 6)(8, "ul", 7);
        i0.ɵɵrepeaterCreate(9, AttributionFactorScatterPlotComponent_For_10_Template, 3, 4, "li", 8, _forTrack0);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(11, "div", 9)(12, "div", 10)(13, "div", 11)(14, "div", 12)(15, "div", 13)(16, "div", 14);
        i0.ɵɵrepeaterCreate(17, AttributionFactorScatterPlotComponent_For_18_Template, 3, 1, "div", 15, i0.ɵɵrepeaterTrackByIdentity);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(19, "div", 16)(20, "div", 17);
        i0.ɵɵelement(21, "ycn-scatter-plot", 18);
        i0.ɵɵelementEnd()()()()()()();
        i0.ɵɵelement(22, "ycn-help-modal", null, 0);
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" Factor ", ctx.ATTRIBUTION_MODE_LABELS[ctx.selectedAttribution], " Scatterplot\u00A0 ");
        i0.ɵɵadvance(6);
        i0.ɵɵrepeater(ctx.periodicityOptions);
        i0.ɵɵadvance(8);
        i0.ɵɵrepeater(ctx.chartLegendItemLabels);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("errorMessage", ctx.error.message)("scatterPlotInfo", ctx.scatterplotData)("status", ctx.status)("ychartsScatterPlotService", ctx.ychartsScatterPlotService);
    } }, dependencies: [i1.NgClass, i2.HelpModalComponent, i3.IconDirective, i4.ScatterPlotComponent], encapsulation: 2 });
